import styled from 'styled-components'

export const RightColumnMatch = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 120px;
  box-sizing: border-box;
  border-radius: ${props => props.theme.primitives.radius.radius2};
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.outline.surface};
`

export const MatchText = styled.p`
  font-size: 12px;
  line-height: ${props => props.theme.size.XXS};
  font-weight: 500;
  color: ${props => props.theme.colors.success.onSurface};
  margin: 0;
`
